// Declare games here that require engine different to their game names
export const ARIS_ENGINE_REPLACEMENTS = {
    JokerHot7sVideoSlot: "BrightStarVideoSlot",
    BookOf7sVideoSlot: "VegasTriplePayDeluxeVideoSlot",
    AnvilTemplateVideoSlot: "VegasTriplePayDeluxeVideoSlot",
    BrightStarNewVideoSlot: "BrightStarVideoSlot",
    DaVinciJewelsV2VideoSlot: "DaVinciJewelsVideoSlot",
};

// Please add inDev: true to games to be hidden to external people
export const ARIS_GAMES = [
    { name: "Select Game" },
    { name: "AnvilTemplate", inDev: true },
    { name: "BeijingNights" },
    { name: "BlazinFireballsSpinNWin" },
    { name: "BookOfChickens" },
    { name: "BrightStarNew", inDev: true },
    { name: "BrightStar" },
    { name: "BrightStarLuckyNight", inDev: true },
    { name: "DaVinciJewels" },
    { name: "DaVinciJewelsV2", inDev: true },
    {name: "EternalPhoenixSpinNWin", inDev: true},
    { name: "FarmyardFortunesSpinNWin" },
    { name: "FinlaysFortunes" },
    { name: "FirestrikeHotHits" },
    { name: "Fortune8" },
    { name: "FountainsOfFortune" },
    { name: "GigaFruits" },
    { name: "GoldStrike" },
    { name: "GoldNSpin" },
    { name: "HawaiianDreams" },
    { name: "JingleBellJackpots" },
    { name: "JuBaoPen", inDev: true },
    { name: "MiamiDice" },
    { name: "MillionairesLife" },
    { name: "MississippiWilds" },
    { name: "PotsOCraic", inDev: true},
    { name: "PowerStrikeHyperHits" },
    { name: "PowerStrikeSplinko", inDev: true },
    { name: "Quarterback" },
    { name: "QuarterbackBlitz", inDev:true},
    { name: "RedHotSlots" },
    { name: "ReturnOfRa" },
    { name: "RichesOfTheIncas" },
    { name: "SlotsOfMoney" },
    { name: "SmokinHotSlots" },
    { name: "SultanOfSpins" },
    { name: "VegasTriplePayDeluxe" },
    { name: "WellOilBe" },
    { name: "WishMeLuck" },
    { name: "WheelBigWinner" },
    { name: "Vegas3XDeluxe" },
    { name: "VegasTriplePaySpinNWin" },
    { name: "WheelBigWinnerMillionairesLife" },
    { name: "WheelBigWinnerPowerTower" },
    { name: "WheelBigWinnerRedHotSpins" },
    { name: "WheelBigWinnerSpinNWin" },
    { name: "ZeusThunderTower" },
];

export const ARIS_USERS = [
    "Birchy",
    "Conor",
    "David",
    "Ed",
    "Goose",
    "Laoganma",
    "Jo",
    "Kent",
    "Mike",
    "Oliver",
    "Robin",
    "Sudeep",
    "Vaibhav",
    "Robyn",
    "Dev",
    "Dev",
    "Dev",
    "Dev",
    "Dev",
    "PromoGames",
    "PromoGames",
    "PromoGames",
    "PromoGames",
    "External",
];

export const ARIS_ENVIRONMENTS = {
    AWS: "https://www.crucibledev.net/dev/aris/",
    Stage: "https://stage.versagaming.net",
    Prod: "https://play.versagaming.net",
};
